export default __webpack_public_path__ + "static/media/trash.36ad1e1e.svg";